module.exports = __webpack_public_path__ + "assets/img/icon_quiz.56e1260b.png";